import script from "./SuggestionsContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuggestionsContainer.vue?vue&type=script&setup=true&lang=ts"

import "./SuggestionsContainer.vue?vue&type=style&index=0&id=d3f35f7a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3f35f7a"]])

export default __exports__